enum RequiredDocumentDetailCategoryCodeEnum {
    PROOF_OF_INCOME = 'PROOF_OF_INCOME',
    PROOF_OF_OTHER_INCOME = 'PROOF_OF_OTHER_INCOME',
}

export default RequiredDocumentDetailCategoryCodeEnum;
